module.exports = __webpack_public_path__ + "media/images/mask-e744d01b34f781c3792d8bb55209add1.png";